import {FormattedMessage} from "react-intl";
import Notify from "./notify";

export const FillRequiredFields = () => Notify('error', 'top-left', <FormattedMessage id="fillFormCorrectly"/>)